import { render } from "./DocumentStatusPill.vue?vue&type=template&id=223f1a1a&scoped=true"
import script from "./DocumentStatusPill.vue?vue&type=script&lang=js"
export * from "./DocumentStatusPill.vue?vue&type=script&lang=js"

import "./DocumentStatusPill.vue?vue&type=style&index=0&id=223f1a1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223f1a1a"]])

export default __exports__